import { unified } from "unified";
import remarkParse from "remark-parse";
import remarkRehype from "remark-rehype";
import rehypeFormat from "rehype-format";
import rehypeSanitize from "rehype-sanitize";
import rehypeStringify from "rehype-stringify";
const markdownCompiler = unified().use(remarkParse).use(remarkRehype, { allowDangerousHtml: true }).use(rehypeSanitize).use(rehypeFormat).use(rehypeStringify);
export function useMarkdownCompiler() {
  const compileMarkdown = async (markdown) => {
    if (!markdown) {
      return "";
    }
    try {
      const result = await markdownCompiler.process(markdown);
      return result.value.toString();
    } catch (error) {
      console.error("Error compiling markdown:", error);
      return "<p>Error compiling markdown</p>";
    }
  };
  return {
    compileMarkdown
  };
}
